import type { PlatformHealthDeepLinks } from "@/lib/dashboardApi";
import { OperatorPanel } from "@/components/admin/dashboard/OperatorPanel";

export function DeepLinksCard({
  data,
}: {
  data: PlatformHealthDeepLinks;
}): JSX.Element {
  const items: Array<[string, string]> = [
    ["Sentry issues", data.sentry_issues],
    ["Better Stack logs", data.better_stack_logs],
    ["Better Stack metrics", data.better_stack_metrics],
  ];
  return (
    <OperatorPanel
      testId="platform-health-deep-links"
      kicker="Jump to"
      title="Deep links"
    >
      <ul className="space-y-1 text-sm">
        {items.map(([label, href]) => (
          <li key={label}>
            <a
              href={href}
              target="_blank"
              rel="noreferrer"
              className="text-text-primary underline hover:text-accent-secondary"
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </OperatorPanel>
  );
}
